import { render, staticRenderFns } from "./AdminVisionDoctor.html?vue&type=template&id=1459344a&external"
import script from "./AdminVisionDoctor.vue?vue&type=script&lang=js"
export * from "./AdminVisionDoctor.vue?vue&type=script&lang=js"
import style0 from "./AdminVisionDoctor.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports